import React from "react";
import { PropTypes } from "prop-types";
import { motion } from "framer-motion";

const variants = {
  visible: (i) => ({
    opacity: 1,
    position: "relative",
  }),
  hidden: {
    opacity: 0,
  },
};

const ChildrenAnimationWrapper = (props) => {
  const { children, itemKey, listStyle } = props;
  return (
    <motion.nav key={itemKey} animate={"visible"} initial="hidden">
      <motion.ul
        variants={variants}
        style={{ listStyle: "none", padding: 0, ...listStyle }}
      >
        {children}
      </motion.ul>
    </motion.nav>
  );
};

ChildrenAnimationWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default ChildrenAnimationWrapper;
